import { render, staticRenderFns } from "./RouteHandler.vue?vue&type=template&id=4c6ccdd6&"
import script from "./RouteHandler.vue?vue&type=script&lang=js&"
export * from "./RouteHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports